import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import {
  Print as PrintIcon,
  ArrowBack as BackIcon,
} from '@mui/icons-material';
import TopSection from '@/components/printPage/topsection/topsection';
import BottomSection from '@/components/printPage/bottomsection/bottomsection';
import '@/components/printPage/style.css';
import '@/components/printPage/font.css';
import '@/components/printPage/layout.css';

interface PrintInvoicePageTestProps {
  user: any;
  onLogout: () => void;
  darkMode: boolean;
  setDarkMode: (darkMode: boolean) => void;
}

const PrintInvoicePageTest: React.FC<PrintInvoicePageTestProps> = ({
  user,
  onLogout,
  darkMode,
  setDarkMode
}) => {
  const navigate = useNavigate();

  // Mock data for testing
  const mockInvoice = {
    "_id": "68fc78e697d3d72aadeb585a",
    "invoice_number": "10/25-26",
    "invoice_date": "2025-10-25T00:00:00.000Z",
    "order_date": "2025-10-24T00:00:00.000Z",
    "order_number": "123456",
    "transport": "Local Transport",
    "customer": {
      "_id": "6885c2c04485ab55578c12c6",
      "id": "CUST-9IIDDE26Z",
      "name": "Test Customer with Long Name",
      "address_1": "123, address line starts here",
      "address_2": "now time for address line 2",
      "address_3": "optional line for address",
      "pin": "123456",
      "tel": "1234567890",
      "mobile": "9876543210",
      "panno": "ABCDE1234F",
      "gst_id": "07ABCDE1234F2Z6",
      "localoutside": "LOCAL",
      "city": "Mumbai",
      "state": "Maharashtra"
    },
    "products": [
      {
        "product": {
          "_id": "6885c2ed4485ab55578c12ca",
          "id": "PROD-M8V5MZCVD",
          "item_code": "ABC00123",
          "item_name": "new-des",
          "rate": 25.5,
          "gst_rate": 18,
          "hsn_code": "9813410",
          "type": "PRODUCT"
        },
        "quantity": 2,
        "poNumber": 123456,
        "_id": "68fc78e697d3d72aadeb585b"
      },
      {
        "product": {
          "_id": "6885f478e2aa6076afd180ba",
          "id": "PROD-EPCA9PGXL",
          "item_code": "new",
          "item_name": "new-test",
          "rate": 120,
          "gst_rate": 18,
          "hsn_code": "1234",
          "type": "PRODUCT"
        },
        "quantity": 3,
        "poNumber": 789012,
        "_id": "68fc78e697d3d72aadeb585c"
      }
    ],
    "bill_amount": 385.5,
    "discount": 0,
    "cgst": 34.695,
    "sgst": 34.695,
    "igst": 0,
    "packing_charges": 0,
    "round_off": 0.11,
    "gross_amount": 455,
    "total_amount": 455,
    "note": "Sample bill with multiple HSN codes"
  };

  const mockCompanyConfig = {
    name: "Regal Engineers",
    logo: "/logo.png",
    phone: "9768802331, 7666412328",
    gstNumber: "27AIFPP6768D1ZX",
    address: "J-17, Swastik Industrial Estate, Near Railway Phatak, Bhayander (East) - 401105"
  };

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate('/management');
  };

  return (
    <Box className="print-page-container">
      {/* Print Controls - Hidden in print */}
      <Box className="print-controls print-no-print">
        <Button
          onClick={handlePrint}
          variant="contained"
          startIcon={<PrintIcon />}
          sx={{ mr: 2 }}
        >
          Print Invoice
        </Button>
        <Button
          onClick={handleBack}
          variant="outlined"
          startIcon={<BackIcon />}
        >
          Back to Management
        </Button>
        <Alert severity="info" sx={{ ml: 2 }}>
          Testing new print system with mock data
        </Alert>
      </Box>

      {/* A4 Container */}
      <Box className="print-a4-container">
        {/* Top Section - Header + Products */}
        <TopSection invoice={mockInvoice} companyConfig={mockCompanyConfig} />
        
        {/* Bottom Section - Footer (Two Columns) */}
        <BottomSection invoice={mockInvoice} companyConfig={mockCompanyConfig} />
      </Box>
    </Box>
  );
};

export default PrintInvoicePageTest;
